// src/hooks/usePopupManager.tsx
import { Typography } from "antd";
import React, {useMemo, useState } from "react";
import LeaseConfiguration from "../components/LeaseConfiguration";

const { Title } = Typography;

// Define type for popup config
interface PopupConfig {
  title: React.ReactNode;
  content: React.ReactNode;
  width?: number;
  style?: React.CSSProperties;
}

export const usePopupManager = () => {
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState<number>(0);
  // All popups list

  const popupList: PopupConfig[] = useMemo(
    () => [
      {
        title: (
          <Title level={3} className="m-0">
            Lease Configurations
          </Title>
        ),
        content: <LeaseConfiguration _visible={visible} onToggle={setVisible} />,
        width: 900,
        style: { padding: "0px" },
      },
    ],
    [visible],
  );

  const popupProps = useMemo(
    () => ({
      closable: true,
      visibility: visible,
      title: popupList[trigger]?.title,
      content: popupList[trigger]?.content,
      width: popupList[trigger]?.width,
      style: popupList[trigger]?.style,
      onCancel: () => setVisible(false),
    }),
    [visible, trigger, popupList],
  );

  return {
    visible,
    setVisible,
    trigger,
    setTrigger,
    popupProps,
  };
};
